import { createQueryFn } from '@oneview/redux/utils';
import { InsightFilterType, InsightTrendingType } from '@orbis-systems/orbis-api-clients/insight';
import { api } from './baseApi';

export const tipranksApi = api.injectEndpoints({
    endpoints: (build) => ({
        getTipranksAnalystRatingsBySymbol: build.query({
            queryFn: createQueryFn(async (symbols: string[], { extra: api }) => {
                return api.orbisMiddleware.tipranks.getTipranksAnalystRatingsBySymbol(symbols, 30);
            }),
        }),
        getTipranksAssetsOverview: build.query({
            queryFn: createQueryFn(async ({ symbols }: { symbols: string[] }, { extra: api }) => {
                return api.orbisMiddleware.tipranks.getTipranksAssetsOverview(symbols);
            }),
        }),
        getTipranksAnalystProfile: build.query({
            queryFn: createQueryFn(async (id: string, { extra: api }) => {
                return api.orbisMiddleware.tipranks.getTipranksAnalystProfile(id);
            }),
        }),
        getTipranksAnalystPortfolio: build.query({
            queryFn: createQueryFn(async (expertUID: string, { extra: api }) => {
                return api.orbisMiddleware.tipranks.getTipranksAnalystPortfolio(expertUID);
            }),
        }),
        getTipranksLivefeedOfAnalystsRatings: build.query({
            queryFn: createQueryFn(({ count, bookmarkId }: { count: number; bookmarkId?: number }, { extra: api }) =>
                api.orbisMiddleware.tipranks.getLivefeedOfAnalystsRatings(count, bookmarkId),
            ),
        }),
        getTipranksTopAnalystRecommendations: build.query({
            queryFn: createQueryFn(
                (
                    {
                        count,
                        period,
                        filter,
                        trendingType,
                    }: {
                        count?: number;
                        period?: number;
                        filter?: InsightFilterType;
                        trendingType?: InsightTrendingType;
                    },
                    { extra: api },
                ) => api.orbisMiddleware.tipranks.getTopAnalystRecommendations(count, period, filter, trendingType),
            ),
        }),
    }),
});

export const {
    useGetTipranksAnalystRatingsBySymbolQuery,
    useGetTipranksAssetsOverviewQuery,
    useGetTipranksAnalystProfileQuery,
    useGetTipranksAnalystPortfolioQuery,
    useGetTipranksLivefeedOfAnalystsRatingsQuery,
    useGetTipranksTopAnalystRecommendationsQuery,
} = tipranksApi;
